import React, { FC } from 'react';
import { channelType } from 'shared/consts';

import './index.scss';

const Loader: FC = () => {
  return <div className={`loader loader__type-${channelType}`} />;
};

export default Loader;
